import { Component, OnInit } from '@angular/core';
import { IModalData } from '@app/models/modal-data.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit {
  modalData: IModalData;

  constructor(public bsModalRef: BsModalRef,
    private modalService: BsModalService,) {
    this.modalData = this.modalService.config.initialState?.modalData as IModalData;
  }

  ngOnInit() {
  }

  closeDialog(): void {
    this.modalService.hide();
  }
}
